import React from 'react'
import { IAttributeFieldProps } from './IAttributeField'

function AttributeFieldString({currValue, setCurrValue}: IAttributeFieldProps) {
  return (
    <input type="text" value={currValue} onChange={(e) => setCurrValue(e.target.value)} className="form-control mb-3" />
  )
}

export default AttributeFieldString